import { format, formatDistanceToNow, parseISO, isPast as _isPast, isFuture as _isFuture, sub } from 'date-fns'
import { de } from 'date-fns/locale';

export const getError = (error: any) => {
    const errorMessage = "API Error, please try again.";

    if (error.name === "Fetch User") {
        return error.message;
    }

    if (!error.response) {
        console.error(`API ${error.config.url} not found`);
        return errorMessage;
    }
    if (process.env.NODE_ENV === "development") {
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
    }
    if (error.response.data && error.response.data.errors) {
        return error.response.data.errors;
    }

    return errorMessage;
};


const priceFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
});

export function formatPrice(price: number) {
    return priceFormatter.format(price / 100.0);
}

export function parseApiTimestamp(datetime: string) {
    return parseISO(datetime);
}

export function formatDatetime(datetime: string, formatString = "dd.MM.yyyy, HH:mm 'Uhr'") {
    return format(parseApiTimestamp(datetime), formatString, { locale: de });
}
export function formatDatetimeWithDayLabel(datetime: string, formatString = "EEEE, dd.MM.yyyy, HH:mm 'Uhr'") {
    return format(parseApiTimestamp(datetime), formatString, { locale: de });
}

export function formatDate(datetime: string, formatString = "dd.MM.yyyy") {
    return format(parseApiTimestamp(datetime), formatString, { locale: de });
}
export function formatDateWithDayLabel(datetime: string, formatString = "EEEE, dd.MM.yyyy") {
    return format(parseApiTimestamp(datetime), formatString, { locale: de });
}

export interface FormatToNowOptions {
    includeSeconds?: boolean,
    addSuffix?: boolean
}
export function formatToNow(datetime: string, options?: FormatToNowOptions) {
    return formatDistanceToNow(parseApiTimestamp(datetime), {
        ...(options || {}),
        locale: de,
    })
}

export function isPast(datetime: string) {
    return _isPast(parseApiTimestamp(datetime));
}
export function isFuture(datetime: string) {
    return _isFuture(parseApiTimestamp(datetime));
}

export function isDatetimeInNextDuration(datetime: string, duration: Duration) {
    return _isPast(sub(parseApiTimestamp(datetime), duration));
}

export function formatTime(hours: number|string|Date, minutes?: number) : string {
    if( hours instanceof Date ) {
        minutes = hours.getMinutes();
        hours = hours.getHours();
    }
    else if( typeof minutes === 'undefined' ) {
        if( typeof hours !== 'string' ) {
            throw new Error('second parameter minutes can not be empty when first parameter hours is not a Date object');
        }
        hours = parseApiTimestamp(hours);
        minutes = hours.getMinutes();
        hours = hours.getHours();
    }

    return (hours + '').padStart(2, '0') + ':' + (minutes + '').padStart(2, '0');
}

/**
 * Unused currently
 *
const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function randomString(length: number) {
    let result = '';
    const charactersLength = characters.length;
    for( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
*/

/*
export const helpers = {
    formatPrice,
};
*/
